import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Mobile <span>App Development Services</span> We Provide
            </h2>
            <p>
              From ground-up launches to component-focused revamps, our mobile
              app development company helps brands tackle modern digital growth
              challenges with custom app development services. Our seasoned team
              of business analysts, project managers, UI/UX designers, core
              mobile app developers, quality testers, and growth strategists is
              here to guide you through each application development stage with
              high efficiency.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start My App Project
            </Link>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="offset-lg-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <Link
                    to="/android-app-development"
                    target="_blank"
                    rel="noopener"
                  >
                    <h4>Android App Development</h4>
                  </Link>
                  <p>
                    Harness the full potential of Android with custom app
                    development using Kotlin, Java, and Jetpack Compose. Our
                    Android experts create versatile, high-performance apps
                    optimized for various devices, ensuring smooth
                    functionality, scalability, and enhanced user engagement,
                    helping brands reach wider audiences with precise,
                    device-specific experiences.
                  </p>
                </div>
                <div className="robust-content">
                  <Link
                    to="/iphone-app-development"
                    target="_blank"
                    rel="noopener"
                  >
                    <h4>iOS App Development</h4>
                  </Link>
                  <p>
                    Develop robust, native iOS apps using Swift and Objective-C.
                    Our iOS developers deliver high-performance apps that meet
                    stringent Apple standards. With expertise in creating apps
                    for iPhones, iPads, Apple Watch, and Apple TV, we build apps
                    that drive user satisfaction and engagement across Apple’s
                    ecosystem.
                  </p>
                </div>
                <div className="robust-content">
                  <Link
                    to="/react-native-app-development"
                    target="_blank"
                    rel="noopener"
                  >
                    <h4>React Native App Development</h4>
                  </Link>
                  <p>
                    Leverage React Native’s efficiency for enterprise-grade
                    mobile apps. Our developers build cross-platform apps with
                    complex integrations and superior performance. We’ve
                    delivered top-ranking apps on both the App Store and Google
                    Play, ensuring seamless functionality and rapid deployment,
                    driving business growth.
                  </p>
                </div>
                <div className="robust-content">
                  <Link
                    to="/flutter-app-development"
                    target="_blank"
                    rel="noopener"
                  >
                    <h4>Flutter App Development</h4>
                  </Link>
                  <p>
                    Utilize Flutter’s powerful widgets and Dart to create
                    stunning, high-performance apps for iOS and Android. Our
                    Flutter developers craft visually captivating UIs and robust
                    back-ends, enabling rapid development and ensuring smooth,
                    consistent performance across platforms, supporting diverse
                    business needs effectively.
                  </p>
                </div>
                <div className="robust-content">
                  <Link
                    to="/cross-platform-app-development"
                    target="_blank"
                    rel="noopener"
                  >
                    <h4>Cross-Platform App Development</h4>
                  </Link>
                  <p>
                    Achieve faster market entry with cross-platform apps using
                    React Native and Flutter. Our developers create apps with a
                    unified codebase that works seamlessly on multiple platforms
                    – reducing development time and cost. This approach allows
                    brands to reach a broader audience efficiently.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Wearables & Embedded Software</h4>
                  <p>
                    Innovate with wearable and embedded software solutions. Our
                    developers use Arduino, PlatformIO, and MBED to create apps
                    for health monitoring, productivity, and more. We build
                    responsive, low-latency apps optimized for wearable devices
                    to enhance user experiences in the connected device
                    ecosystem.
                  </p>
                </div>
                <div className="robust-content">
                  <Link to="/game-development" target="_blank" rel="noopener">
                    <h4>Mobile Game App Development</h4>
                  </Link>
                  <p>
                    Create immersive, high-performance games across platforms.
                    Our game developers use Unity, Unreal Engine, and Cocos2d to
                    build visually stunning, responsive games with optimized
                    mechanics. We focus on delivering games that captivate users
                    and ensure smooth gameplay to drive both user retention and
                    monetization.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
